import { Typography } from '@mui/material';

const LabelContent = ({ 
  label, 
  content, 
  labelColor,
  contentColor,
  separator = ': ',
  variant = 'body1',
  component = 'span',
  sx = {},
  labelSx = {},
  contentSx = {},
  ...props 
}) => {
  return (
    <Typography 
      variant={variant} 
      component={component} 
      sx={{ 
        fontSize: { xs: '12px', md: '14px' },
        ...sx 
      }} 
      {...props}
    >
      <Typography
        component="span"
        sx={{
          fontWeight: 'bold',
          color: labelColor,
          ...labelSx
        }}
      >
        {label}
      </Typography>
      {separator}
      <Typography
        component="span"
        sx={{
          fontWeight: 'normal',
          color: contentColor,
          ...contentSx
        }}
      >
        {content}
      </Typography>
    </Typography>
  );
};

export default LabelContent;